import { SITE } from "@/constants/testIds";
import {
  HeartHandshake,
  TreePine,
  Eye,
  Hand,
  Sparkles,
  Waves,
} from "lucide-react";

const BG =
  "https://images.pexels.com/photos/953178/pexels-photo-953178.jpeg?auto=compress&cs=tinysrgb&w=2000";

const items = [
  { slug: "motor-skills", label: "Learn Something New", Icon: Hand },
  { slug: "relax-mind", label: "Relax Your Mind", Icon: Sparkles },
  { slug: "connect-nature", label: "Connect With Nature", Icon: TreePine },
  { slug: "improve-focus", label: "Revive Your Spirit", Icon: Eye },
  { slug: "self-confidence", label: "Improve Self Confidence", Icon: HeartHandshake },
  { slug: "cast-worries", label: "Cast Away Worries", Icon: Waves },
];

export default function Benefits() {
  return (
    <section
      id="benefits"
      data-testid={SITE.benefits}
      className="relative isolate overflow-hidden"
    >
      <img
        src={BG}
        alt="Tranquil river with green grass on the banks"
        className="absolute inset-0 h-full w-full object-cover"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-brand-evergreen/80" />

      <div className="relative z-10 mx-auto max-w-7xl px-6 py-24 md:px-10 md:py-32">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-xs uppercase tracking-[0.35em] text-brand-sand">
            The benefits
          </span>
          <h2 className="mt-3 font-display text-4xl leading-tight text-brand-cream sm:text-5xl lg:text-6xl">
            More than a cast
          </h2>
          <p className="mt-5 text-lg text-brand-cream/80">
            Fly casting teaches patience, presence, and play — at any age
          </p>
        </div>

        <ul className="mt-16 grid grid-cols-2 gap-4 sm:gap-6 md:grid-cols-3">
          {items.map(({ slug, label, Icon }) => (
            <li
              key={slug}
              data-testid={SITE.benefitItem(slug)}
              className="flex flex-col items-center gap-4 rounded-2xl border border-brand-cream/15 bg-brand-cream/5 p-6 text-center backdrop-blur-sm"
            >
              <span className="flex h-14 w-14 items-center justify-center rounded-full bg-brand-sand/20 text-brand-sand">
                <Icon className="h-6 w-6" />
              </span>
              <span className="font-display text-lg leading-tight text-brand-cream">
                {label}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
